const CUSTOMER_DRIVE_INNOVATION_GUIDE = "CUSTOMER_DRIVE_INNOVATION_GUIDE" ;
const DEEP_CUSTOMER_EMPATHY_GUIDE = "DEEP_CUSTOMER_EMPATHY_GUIDE" ;
const FOLLOW_ME_HOME_GUIDE = 'FOLLOW_ME_HOME_GUIDE';
const CUSTOMER_INTERVIEW_GUIDE = 'CUSTOMER_INTERVIEW_GUIDE';
const INTERVIEW_QUESTION_GUIDE = 'INTERVIEW_QUESTION_GUIDE';
const CUSTOMER_PROBLEM_STATEMENT_GUIDE = 'CUSTOMER_PROBLEM_STATEMENT_GUIDE';
const IDEAL_STATE = 'IDEAL_STATE';
const GO_BROAD_TO_GO_NARROW = 'GO_BROAD_TO_GO_NARROW';
const BRAINSTORMING = 'BRAINSTORMING';
const POINTS_NARROWING = 'POINTS_NARROWING';
const NARROWING = 'NARROWING';
const SKETCH_PROTOTYPE = 'SKETCH_PROTOTYPE';
const RAPID_EXPERIMENTS = 'RAPID_EXPERIMENTS';
const LEAP_FAITH_ASSUMPTIONS = 'LEAP_FAITH_ASSUMPTIONS';
const TYPES_EXPERIMENTS = 'TYPES_EXPERIMENTS';
const TEST_HYPOTHESIS_TEST_PLAN = 'TEST_HYPOTHESIS_TEST_PLAN';

const listStyleGuide = {
    CUSTOMER_DRIVE_INNOVATION_GUIDE: {
        title: "Customer Driven Innovation Guide",
        image: {
           filename:"customer-drive-innovation-guide.png",
           placeholder : "Use CDI diagram in Basecamp docs & files."
        },
        content : [
            {
                "title": "What is it?",
                "body": [
                    "Customer Driven Innovation describes the three questions you can use to help you find a problem area to work on. You may not know the exact problem you want to solve, but using the Customer Driven Innovation framework can help you find a general topic, where you will have the most opportunity to create something useful and innovative. "
                ]
            },
            {
                "title": "How to do it",
                "body": [
                    "Using the Customer Driven Innovation diagram as a guide, discuss these questions with your team: ",
                    "1. What are some of the biggest unsolved problems for the people we want to help (your customers)?",
                    "2. What are some of the things we are most knowledgeable or skilled at now, or that we could learn about?",
                    "3. How would we be able to have a competitive advantage, which means we would be able to offer a solution that is new, and that other people would not be able to easily copy? ",
                    "4. To move forward with using Design for Delight, identify one topic that you think is in the center of the Customer Driven Innovation diagram: an unsolved problem for our customer, that we believe we can solve well, and where we have the opportunity to create something new and valuable. "
                ]
            }
        ]
    },
    DEEP_CUSTOMER_EMPATHY_GUIDE : {
        title: "Deep Customer Empathy Guide",
        content : [
            {
                "title": "What is it?",
                "body": [
                    "Deep customer empathy is when we understand our customer's problems by observing and talking to them directly, instead of relying only on indirect sources of information like the Internet, books, or videos. "
                ]
            },
            {
                "title": "How to do it",
                "body": [
                    "1. Use the Customer Driven Innovation guide to identify a general topic you want to learn more about from your customers.",
                    "2. Use the Follow Me Home or Customer Interview guides to learn from your customers. " ,
                    "3. Try to avoid making assumptions about your customers and their problems, just based on what you already know. Keep an open mind and look for things that surprise you -- this is often where innovation begins! "
                ]
            }
        ]
    },
    FOLLOW_ME_HOME_GUIDE: {
        title: "\"Follow Me Home\" Guide",
        image: {
            filename: "follow-me-home-guide.png",
            placeholder: "Photo / illustration showing a Follow Me Home"
        },
        content: [
            {
                "title": "What is it?",
                "body": [
                    "A “Follow Me Home” is when you observe real customers in real-world situations. It does NOT mean you have to literally go to their homes. Observing people in their natural environments allows us to see and understand their real problems and needs, not just what they say they want."
                ]
            },
            {
                "title": "How to do it",
                "body": [
                    "1. Find real customers (or potential customers) who will let you observe them in real life.",
                    "2. With you partner or team, meet the customer in one of their natural environments. It can be at work, school, or a public place, or their home (if you and they are comfortable doing so). ",
                    "3. Observe the customer doing activities or tasks related to your project, and ask them to explain what they’re doing and why.",
                    "4. After saying goodbye to your customer, discuss what you learned with your team. Share what you observed, what surprised you, and when the customer had the most frustration, difficulty or confusion. These “Pain points” are opportunities for you to help!"
                ]
            }
        ]
    },
    CUSTOMER_INTERVIEW_GUIDE: {
        title: "Customer Interview Guide",
        content: [
            {
                "title": "What is it?",
                "body": [
                    "Observing behavior shows us what people do, but not why they do it. Customer interviews are one way to understand why people behave as they do. They work best when combined with a live observation or \"Follow Me Home\"."
                ]
            },
            {
                "title": "How to do it",
                "body": [
                    "1. Decide what behavior you want to learn more about (for example, why are customers canceling their subscriptions).",
                    "2. Find people at the time, or right after they do the behavior you are curious about. For example, call customers right after they cancel their subscription.",
                    "3. Ask specific questions to understand why people did the behavior."
                ]
            }
        ]
    },
    INTERVIEW_QUESTION_GUIDE: {
        title: "Interview Question Guide",
        content: [
            {
                "title": "Prepare for a Customer Interview",
                "body": [
                    "Spend a few minutes practicing together as a team and trying some of the example questions in this guide. Role-play a few practice interviews so the team can watch one another."
                ]
            },
            {
                "title": "General Questions",
                "body": [
                    "Can you tell me more about that?",
                    "Why is that good? (if customer mentions something good)",
                    "Why is that bad? (if customer mentions something bad) How does that happen?",
                    "Tell me the steps you went through.",
                    "What did you mean by that?",
                    "What was going through your mind at the time?",
                    "Can you give me an example?",
                    "Why do you think that happened?"
                ]
            },
            {
                "title": "Goal Related ",
                "body": [
                    "What were you trying to do?",
                    "What did you want to happen?",
                    "What did you think was going to happen?"
                ]
            },
            {
                title: "Confirm",
                body: [
                    "Can you say that again to make sure I got it?",
                    "Let me summarize what you said to make sure I understand..."
                ]
            }
        ]
    },
    CUSTOMER_PROBLEM_STATEMENT_GUIDE: {
        title: "Customer Problem Statement Guide",
        content: [
            {
                title: "What is it?",
                body: ["Before we attempt to solve a problem, the most important thing to agree on as a team is what the problem actually is. Customer Problem Statements summarize the problem in a clear and easy to communicate format."]
            },
            {
                title: 'How to do it',
                body: [
                    "1. Do customer observations and interviews.",
                    "2. Discuss what you learned from doing Customer Empathy with your team.",
                    "3. Complete the Customer Problem Statement template with your team.",
                    "4. Remember, the \"I\" in the Customer Problem Statement is the customer, not you.",
                    "5. Avoid suggesting a solution in the Customer Problem Statement."
                ]
            },
            {
                title: 'Example',
                body: [
                    "I am... a busy high school student with lots of homework",
                    "I am trying to... find information on the Internet that will help me finish my homework",
                    "But... it takes a long time to find anything useful",
                    "Because... because search results aren't relevant or don't have accurate information",
                    "Which makes me feel... stressed, because I have to turn my homework in on time!"
                ]
            }
        ]
    },
    IDEAL_STATE: {
        title: "Ideal State",
        content: [
            {
                title: "What is it?",
                body: [
                    "The Ideal State is a description of a future state where an important customer problem or opportunity has been solved to such an amazing degree that the outcome seems almost impossible.“For example, the Khan Academy describes their goal as, “providing a completely free education to every single person on earth.” ” "
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Start by reviewing your Customer Problem Statement.",
                    "2. From the customer’s point of view, imagine “a perfect world” in the customer’s future, without coming up with any specific solutions.",
                    "3. Complete the Ideal State template with your team."
                ]
            },
            {
                title: "Example",
                body: [
                    "In a perfect world... I can get all the information I need on the Internet, instantly",
                    "The biggest benefit to me is... I can finish my homework so quickly that I have time to do more fun things!",
                    "Which makes me feel... relieved and excited"
                ]
            }
        ]

    },
    GO_BROAD_TO_GO_NARROW: {
        title: "Go Broad to Go Narrow",
        content: [
            {
                title: "What is it?",
                body: [
                    "Go Broad means coming up with lots of ideas that could help solve your customer's problem. Go Narrow means choosing just one idea to test with customers.",
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Make sure you have a clear Customer Problem Statement and Ideal State based on your Follow Me Homes or Customer Interviews.",
                    "2. Brainstorm as many ideas as you can that would creatively and positively impact the customer's life, getting them closer to their Ideal State.",
                    "3. Select one idea that you are going to prototype and then test with customers.",
                ]
            },
            {
                title: "  Tip",
                body: [
                    "Remember, going narrow doesn't mean you're picking your final product or service. It's just the first idea you're going to test. You can change your mind later!"
                ],
                isTip: true
            }

        ]
    },
    BRAINSTORMING: {
        title: "Brainstorming",
        image: {
            filename: "brainstorming.png",
            placeholder: "show an example result of brainstorming -- a lot of ideas, some sketches, doodles, emojis etc."
        },
        content: [
            {
                title: "What is it?",
                body: ["Brainstorming is a process for coming up with lots of innovative ideas"]
            },
            {
                title: "How to do it",
                body: [
                    "1. Set a timer for 5 minutes for each round of brainstorming. Always brainstorm individually first -- no talking!",
                    "2. Write down as many ideas as you can to help solve the customer problem. Go for wild, new, big ideas!",
                    "3. Share your ideas with your team one by one. Don't judge or criticize anyone's ideas.",
                    "4. Do additional round of brainstorming individually, now trying to build on others' ideas."
                ]
            },
            {
                title: " Tip",
                isTip: true,
                body: [
                    "Push yourself to keep coming up with ideas even when you feel \"stuck\". Don't worry if your idea seems impossible right now."
                ]
            }
        ]
    },
    POINTS_NARROWING: {
        title: "100 Points Narrowing",
        image: {
            filename: "100-points-narrowing.png",
            placeholder: "Show how 100 point exercise works with post it notes."
        },
        content: [
            {
                title: "What is it? ",
                body: ["100 points is a method for getting a team to agree on a single idea to move forward with."]
            },
            {
                title: "How to do it",
                body: [
                    "1. Get all your ideas for how to solve the customer problem on a white board or shared document. Make sure to remove duplicate ideas.",
                    "2. Every team member has 100 points to \"spend\" on the ideas they think will be most likely to solve the customer problem.",
                    "3. Using post-it notes or other method for voting, have each team member put the number of points they want to give to each idea.",
                    "4. Add up all the points for each idea.",
                    "5. Discuss if you are all comfortable moving forward with the idea with the most points.",
                    "6. If the decision is not clear, spread your 100 points across the top 2-3 ideas from the first round of points (ignore the other ideas)."
                ]
            }
        ]
    },
    NARROWING: {
        title: "2x2 Narrowing",
        image: {
            filename: "2x2-narrowing.png",
            placeholder: "show an example 2x2 map with the labels on each point. Highlight the top right corner or star the winning idea.",
        },
        content: [
            {
                title: "What is it?",
                body: [
                    "2x2 Narrowing is a method for getting a team to agree on a single idea to move forward with."
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Draw a big cross on a whiteboard or piece of poster paper.",
                    "2. Label each end point like in the diagram below. Top:  Solves Customer Problem. Bottom: May Not Solve Customer Problem. Left: May Not Delight Customer. Right: Delights Customer.",
                    "3. Organize your ideas from brainstorming according to where they belong on the 2x2 map.",
                    "4. Discuss ideas until you agree where they should be placed on the map.",
                    "5. Choose one idea from the top right corner."
                ]
            }
        ]
    },
    SKETCH_PROTOTYPE: {
        title: "Sketch Prototype",
        image: {
            filename: "sketch-prototype.png",
            placeholder: "An example sketch prototype with maybe 3 steps -- customer problem, them discovering the solution, and them using the solution ,... like a short storyboard. Not too many words.",
        },
        content: [
            {
                title: "What is it?",
                body: [
                    "A sketch prototype is a rough, simple drawing of your idea on a piece of paper."
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Use the 100 Points or 2x2 Narrowing exercise to select an idea to test.",
                    "2. On a piece of paper, draw your idea. You can show multiple steps or a single idea.",
                    "3. Try not to use too many words to describe or explain the idea.",
                    "4. Try drawing a few different versions with your team to figure out important details of how the idea will work."
                ]
            }
        ]
    },
    RAPID_EXPERIMENTS: {
        title: "Rapid Experiments with Customers",
        content: [
            {
                title: "What is it?",
                body: [
                    "Rapid Experiments with Customers is when we do quick, cheap experiments with real people to find out if our idea works, or how we can improve it. The goal of doing fast experiments is to learn before committing to building a product or starting a business."
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Identify your Leap of Faith Assumptions for the idea you want to try out.",
                    "2. Create a Test Hypothesis (Test Plan) that's fast and cheap to do.",
                    "3. Run your experiment with real people (not just your team or friends)!",
                    "4. Based on your results, decide if you will continue with your idea, improve it, or go back and try to come up a new idea."
                ]
            },
            {
                title: " Tip",
                isTip: true,
                body: [
                    "Don't use surveys to test your idea. Surveys can only tell you what customers say, not what they will do in real life."
                ]
            }
        ]
    },
    LEAP_FAITH_ASSUMPTIONS: {
        title: "Leap of Faith Assumptions",
        content: [
            {
                title: "What is it?",
                body: [
                    "Leap of Faith Assumptions are the things that need to be true for your idea to work, and that you currently don't know if they are true. By figuring out your Leap of Faith Assumptions, you can test the biggest risks in your idea before you spend a lot of time or money."
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. With your team, write down all the things that need to be true for your idea to work. Many of these things are already well known. These are assumptions.",
                    "2. After writing down a big list of thing that need to be true, circle or star the ones that you don't know yet if they are true. These are \"Leap of Faith\" assumptions.",
                    "3. Identify the most risky Leap of Faith Assumption -- the one that, if it's not true, your entire idea will not work. This is the Leap of Faith Assumption that you are going to test with an experiment."
                ]
            },
            {
                title: "Example",
                body: [
                    "Assumption: College students need help with homework (this is known to be true)",
                    "Leap of Faith Assumption: College students are willing to pay a monthly subscription fee for homework help (this is not known to be true)"
                ]
            }
        ]

    },
    TYPES_EXPERIMENTS: {
        title: "Five Types of Experiments",
        image: {
            filename: "types-of-experiments.png",
            placeholder: "An image of a web page with a \"sign up now\" button for an example product idea.  Or, a sign up booth or sheet. [The goal is to show a 'Pre-order' test that finds out if customers are interested before building the product]",
        },
        content: [
            {
                title: "What is it? ",
                body: [
                    "Experiments are tests with real customers that help you learn if your idea is going to work and how to improve it."
                ]
            },
            {
                title: "Five Types of Experiments",
                body: [
                    "1. Prototype Test: Show customers a rough prototype of your product (like a sketch on paper) and see how they would use it.",
                    "2. \"Fake\" Test:  Fake some part of your product in order to test it. For example, you could offer customers the opportunity to sign up for your product and see how many people are willing to pre-order it, even if it doesn't exist yet.",
                    "3. Concierge Test: Use your team to \"act out\" how the product would work for the customer.",
                    "4. Technical Test: Try to make your product to find out if it's possible." ,
                    "5.  A/B Test: Compare an existing product (\"A\") with your new product (\"B\") to see if your new product improves the customer experience."
                ]
            }
        ]
    },
    TEST_HYPOTHESIS_TEST_PLAN: {
        title: "Test Hypothesis (Test Plan)",
        content: [
            {
                title: "What is it?",
                body: [
                    "A Test Hypothesis is a specific plan for how you will test your riskiest Leap of Faith Assumption."
                ]
            },
            {
                title: "How to do it",
                body: [
                    "1. Using the Hypothesis Template, describe how your team will run the experiment.",
                    "2. Then, describe how you hope your customer will act.",
                    "3. Add a way to measure customer behavior.",
                    "4. Define a percentage or number of customers who need to behave as you expected in order for the test to be successful"
                ]
            },
            {
                title: "Example",
                body: [
                    "If we...  give customers paper version of our mobile app with each screen drawn on paper (A sketch prototype test)",
                    "Then... customers will be able to find all the primary features by using the in-product navigation buttons and menu",
                    "Which we will measure by... how many customers get to the final page of the app",
                    "Success for this metric will be: 6 out of 10 test customers get to the final page of the app without significant help"
                ]
            },
            {
                title: " Tip",
                isTip: true,
                body: [
                    "Don't test your entire idea all at once. Just pick one part of your idea to test, and do it quickly and cheaply."
                ]
            },
        ]
    }
}

const getStyleGuide = (styleGuide) => {
    try {
        return listStyleGuide[styleGuide]
    } catch (e) {
        return {}
    }
}

export default {
    CUSTOMER_DRIVE_INNOVATION_GUIDE,
    DEEP_CUSTOMER_EMPATHY_GUIDE,
    FOLLOW_ME_HOME_GUIDE,
    CUSTOMER_INTERVIEW_GUIDE,
    INTERVIEW_QUESTION_GUIDE,
    CUSTOMER_PROBLEM_STATEMENT_GUIDE,
    IDEAL_STATE,
    GO_BROAD_TO_GO_NARROW,
    BRAINSTORMING,
    POINTS_NARROWING,
    NARROWING,
    SKETCH_PROTOTYPE,
    RAPID_EXPERIMENTS,
    LEAP_FAITH_ASSUMPTIONS,
    TYPES_EXPERIMENTS,
    TEST_HYPOTHESIS_TEST_PLAN,
    getStyleGuide,
    listStyleGuide
}
